var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommendation-letters"},[_c('SeparatedList',{attrs:{"items":_vm.letters},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('RecommendationLetterItem',{attrs:{"letter":item,"approve-fallback-href":_vm.approveFallbackHref}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }